<script>
  export default {
    name: 'resource-home',
    data: () => ({
      links: [
        {
          icon: 'mdi-blood-bag',
          label: 'Blood Pressure Kit',
          slug: 'blood-pressure-kit'
        },
        {
          icon: 'mdi-account-tie-woman',
          label: 'Career Counselor',
          slug: 'career-counselor'
        },
        {
          icon: 'mdi-ticket',
          label: 'Discount Tickets',
          slug: 'dicount-tickets'
        },
        {
          icon: 'mdi-mailbox',
          label: 'Homebound Program',
          slug: 'homebound-program'
        },
        {
          icon: 'mdi-card-bulleted',
          label: 'Library Card',
          slug: 'library-card'
        },

        {
          icon: 'mdi-tennis',
          label: 'Library of Things',
          slug: 'library-of-things'
        },
        {
          icon: 'mdi-home-variant-outline',
          label: 'Little Free Library',
          slug: 'little-free-library'
        },

        {
          icon: 'mdi-printer-3d',
          label: 'Maker Lab',
          slug: 'makerlab'
        },
        {
          icon: 'mdi-bank',
          label: 'Museum Passes',
          slug: 'museum-passes'
        },
        {
          icon: 'mdi-email-newsletter',
          label: 'NextReads',
          slug: 'next-reads'
        },
        {
          icon: 'mdi-printer-wireless',
          label: 'Remote Printing',
          slug: 'remote-printing'
        },
        {
          icon: 'mdi-book-heart',
          label: 'Select Books',
          slug: 'select-books'
        }
      ]
    })
  }
</script>

<template>
  <v-container>
    <h1 class="text-h2 primary--text font-weight-bold text-center mb-8">Library Services</h1>
    <v-row align="center" justify="center" class="my-16">
      <v-col v-for="link in links" :key="link.key" cols="11" md="5">
        <v-card hover :to="`/services/${link.slug}`"
          ><v-card-text class="d-flex align-center font-weight-bold primary--text text-h6">
            <v-icon color="primary" x-large class="mr-4">mdi {{ link.icon }}</v-icon> {{ link.label }}</v-card-text
          ></v-card
        >
      </v-col>
      <!-- dummy col for alignment -->
      <v-col cols="12" sm="5" />
    </v-row>
  </v-container>
</template>

<style></style>
